import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
// Also imported for its side effect: initialises i18next (French by default) before the first
// render, so no component ever mounts against an empty catalogue. The instance itself is used for
// the error-boundary fallback, which renders outside any component that could hold a hook.
import i18n from './i18n';
import App from './App';

// Sentry stays inert when VITE_SENTRY_DSN is unset (e.g. local dev).
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    // Performance tracing sample rate; tune via env. No Session Replay by
    // default — it records user sessions and needs a GDPR review first.
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1'),
  });
}

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>{i18n.t('common.somethingWentWrong')}</p>}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
